module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('main', {
    staticClass: "mdc-toolbar-fixed-adjust"
  }, [_c('div', {
    staticClass: "mdc-layout-grid app-grid"
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 69
// module chunks = 1